export default __webpack_public_path__ + "static/media/sports_banner2.2fa0ee89.png";